import { render, staticRenderFns } from "./ProductBill.vue?vue&type=template&id=54189293&scoped=true"
import script from "./ProductBill.vue?vue&type=script&lang=js"
export * from "./ProductBill.vue?vue&type=script&lang=js"
import style0 from "./ProductBill.vue?vue&type=style&index=0&id=54189293&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54189293",
  null
  
)

export default component.exports